import { render, staticRenderFns } from "./ProjectInstallation.vue?vue&type=template&id=3fc2a3eb&scoped=true"
import script from "./ProjectInstallation.vue?vue&type=script&lang=js"
export * from "./ProjectInstallation.vue?vue&type=script&lang=js"
import style0 from "./ProjectInstallation.vue?vue&type=style&index=0&id=3fc2a3eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc2a3eb",
  null
  
)

export default component.exports